import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { createApiClient } from '../api/helpers.ts'
import { env } from '../env.ts'

const InsightApi = createApiClient({ prefixUrl: env.API_INSIGHT })

export const insightTokenQuery = queryOptions({
	queryKey: ['INSIGHT_TOKENS'],
	queryFn: () =>
		Promise.resolve({
			XWEATHER: env.XWEATHER_SECRET,
			MAPBOX: env.MAPBOX_SECRET,
		}),
	retry: 3,
	staleTime: 1000 * 60 * 60,
})

export const useInsightTokens = () => {
	return useSuspenseQuery(insightTokenQuery)
}

export const fetchIntercomToken = async () => {
	const { token } = await InsightApi.get('intercom/token').json<{ token: string }>()
	return token
}
